const mobileQuery = window.matchMedia('(max-width: 749px)');

function prepareProductLayout(component) {
  if (component.dataset.sdMobileOrderReady === 'true') return;

  const slot = component.querySelector('[data-sd-mobile-product-summary]');
  const details = component.querySelector('.product-details');
  const title = details?.querySelector('h1')?.closest('.text-block');
  const inventory = details?.querySelector('product-inventory');
  const centerAssurance = details?.querySelector('.sd-product-assurance[data-block-id*="assurance_center"]');
  const centerGroup = title?.closest('.group-block');
  const variantPicker = details?.querySelector('variant-picker');
  const price = details?.querySelector('product-price');
  const taxText = price?.parentElement?.querySelector('.text-block p')?.closest('.text-block');
  const purchaseGroup = price?.closest('.group-block');

  if (!slot || !details || !title || !inventory) return;

  component.dataset.sdMobileOrderReady = 'true';

  const movableSummaryNodes = [title, price, taxText, inventory, centerAssurance].filter(Boolean);
  const summaryAnchors = movableSummaryNodes.map((node) => {
    const anchor = document.createComment('sd-mobile-order-anchor');
    node.before(anchor);
    return { node, anchor };
  });

  const syncLayout = () => {
    if (mobileQuery.matches) {
      summaryAnchors.forEach(({ node }) => slot.append(node));
      centerGroup?.classList.add('sd-mobile-source-empty');
      purchaseGroup?.classList.add('sd-mobile-purchase-group');
      variantPicker?.classList.add('sd-mobile-variant-after-info');
    } else {
      summaryAnchors.forEach(({ node, anchor }) => anchor.after(node));
      centerGroup?.classList.remove('sd-mobile-source-empty');
      purchaseGroup?.classList.remove('sd-mobile-purchase-group');
      variantPicker?.classList.remove('sd-mobile-variant-after-info');
    }
  };

  mobileQuery.addEventListener('change', syncLayout);
  syncLayout();
}

function initializeProductLayouts(root = document) {
  root.querySelectorAll('product-component[data-product-grid-content]').forEach(prepareProductLayout);
}

initializeProductLayouts();
document.addEventListener('shopify:section:load', (event) => initializeProductLayouts(event.target));
